import React, { SVGProps } from "react"

export function AFLogo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="14"
      viewBox="0 0 30 14"
      fill="none"
      {...props}
    >
      <path
        d="M14.2808 6.97425L20.0172 13.8772C20.0819 13.9552 20.1762 14 20.2753 14H27.7542C28.0357 14 28.1961 13.6655 28.0265 13.4319L21.3599 4.25C17.5864 4.24791 16.2092 5.0278 14.2808 6.97425Z"
        fill="url(#paint0_linear_2001_94)"
      />
      <path
        d="M21.4282 3.59629C18.0158 -1.10355 11.2239 -1.10355 7.81151 3.59629L0.874136 13.1511C0.704531 13.3846 0.864881 13.7192 1.14647 13.7192H9.48443C9.59302 13.7192 9.69517 13.6654 9.75944 13.5744L14.6199 6.69344C16.5483 4.747 17.9255 3.96711 21.699 3.9692L21.4282 3.59629Z"
        fill="url(#paint1_linear_2001_94)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2001_94"
          x1="17.6924"
          y1="5.49091"
          x2="30.9729"
          y2="20.0498"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopColor="#666666" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2001_94"
          x1="1.65573"
          y1="13.7192"
          x2="13.2728"
          y2="-0.586789"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopColor="#9C9C9C" />
        </linearGradient>
      </defs>
    </svg>
  )
}
